// src/api/reviewSetApi.ts
import { apiClient } from '@/services/apiClient';
import type {
  ReviewSetTemplateSummaryDto,
  ReviewSetTemplateDetailDto,
  CreateReviewSetTemplateRequest,
  UpdateReviewSetTemplateRequest,
  ReviewSetInstanceSummaryDto,
  ReviewSetInstanceDetailDto,
  AdminReviewSetSummaryDto,
  AssignReviewSetRequest,
} from '@/types/reviews';

// ---- Admin: Templates ----

export async function getSetTemplates(includeInactive = false): Promise<ReviewSetTemplateSummaryDto[]> {
  const res = await apiClient.get<ReviewSetTemplateSummaryDto[]>(
    `/api/admin/review-sets/templates?includeInactive=${includeInactive}`
  );
  return res.data;
}

export async function getSetTemplateDetail(setTemplateGuid: string): Promise<ReviewSetTemplateDetailDto> {
  const res = await apiClient.get<ReviewSetTemplateDetailDto>(
    `/api/admin/review-sets/templates/${setTemplateGuid}`
  );
  return res.data;
}

export async function createSetTemplate(request: CreateReviewSetTemplateRequest): Promise<{ setTemplateGuid: string; message: string }> {
  const res = await apiClient.post<{ setTemplateGuid: string; message: string }>(
    '/api/admin/review-sets/templates',
    request
  );
  return res.data;
}

export async function updateSetTemplate(setTemplateGuid: string, request: UpdateReviewSetTemplateRequest): Promise<{ message: string }> {
  const res = await apiClient.put<{ message: string }>(
    `/api/admin/review-sets/templates/${setTemplateGuid}`,
    request
  );
  return res.data;
}

// ---- Admin: Set Instances ----

export async function getAllReviewSets(): Promise<AdminReviewSetSummaryDto[]> {
  const res = await apiClient.get<AdminReviewSetSummaryDto[]>('/api/admin/review-sets');
  return res.data;
}

export async function assignReviewSet(request: AssignReviewSetRequest): Promise<{ setInstanceGuid: string; message: string }> {
  const res = await apiClient.post<{ setInstanceGuid: string; message: string }>(
    '/api/admin/review-sets/assign',
    request
  );
  return res.data;
}

// ---- User: Set Instances ----

export async function getMyReviewSets(): Promise<ReviewSetInstanceSummaryDto[]> {
  const res = await apiClient.get<ReviewSetInstanceSummaryDto[]>('/api/review-sets/my');
  return res.data;
}

export async function getReviewSetDetail(setInstanceGuid: string): Promise<ReviewSetInstanceDetailDto> {
  const res = await apiClient.get<ReviewSetInstanceDetailDto>(`/api/review-sets/${setInstanceGuid}`);
  return res.data;
}
